import type { BadgeProps } from '@chakra-ui/react';
import { Badge } from '@chakra-ui/react';
import { PayoutTransferStatus } from '@fluenceur/types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { TRANSFER_NOT_SENT } from './transferDisplayState';

interface TransferStatusBadgeProps extends BadgeProps {
  status?: PayoutTransferStatus | string;
}

const statusColorMap: Partial<Record<PayoutTransferStatus | string, string>> = {
  [PayoutTransferStatus.SUCCEEDED]: 'green',
  [PayoutTransferStatus.PENDING]: 'yellow',
  [PayoutTransferStatus.FAILED]: 'red',
  // Never attempted, so neither a success nor a failure.
  [TRANSFER_NOT_SENT]: 'gray',
};

const statusTranslationKeys: Partial<Record<PayoutTransferStatus | string, string>> = {
  [PayoutTransferStatus.SUCCEEDED]: 'payouts.transferStatus.succeeded',
  [PayoutTransferStatus.PENDING]: 'payouts.transferStatus.pending',
  [PayoutTransferStatus.FAILED]: 'payouts.transferStatus.failed',
  [TRANSFER_NOT_SENT]: 'payouts.transferStatus.notSent',
};

const TransferStatusBadge: React.FC<TransferStatusBadgeProps> = ({ status, ...props }) => {
  const { t } = useTranslation();

  if (!status) return null;

  const colorPalette = statusColorMap[status];
  const translationKey = statusTranslationKeys[status];
  const text = translationKey ? t(translationKey) : String(status);

  if (!colorPalette) return null; // Handle potential unknown statuses gracefully

  return (
    <Badge colorPalette={colorPalette} {...props}>
      {text}
    </Badge>
  );
};

export default TransferStatusBadge;
